import './Loader.scss'

import { Spinner } from '@tallink/components-lib'
import React from 'react'

export default function Loader() {
  return (
    <div className="loader">
      <Spinner />
    </div>
  )
}
